<template>
  <div id="setAccount">
    <el-form label-width="200px"  class="demo-ruleForm setAccount-form" :model="setAccountForm" ref="setAccountForm" :rules="setAccountFormRules">
      <el-form-item prop="mobile" label="绑定手机号" class="phone-input">
        <el-input v-model="setAccountForm.mobile" disabled></el-input>
      </el-form-item>
      <el-form-item prop="picSmsCode" label="图片验证码" class="code-input">
        <el-input  v-model="setAccountForm.picSmsCode" :maxlength="4" placeholder="请输入图形验证码"></el-input><img class="picture-sms-code code-btn" @click="refreshPic(setAccountInfo.authCode)" alt="" :src="src"/>
      </el-form-item>
      <el-form-item prop="smsCode" label="短信验证码" class="code-input">
        <el-input  v-model="setAccountForm.smsCode" :maxlength="6" placeholder="请输入短信验证码"></el-input><el-button class="sms-code-btn code-btn" @click="sendSmsCode" :disabled="timeText >= 0">{{timeText >= 0 ? timeText + 's' : '获取验证码'}}</el-button>
      </el-form-item>
      <el-form-item label-width="0" class="form-btn">
        <el-button class="y-w-100" @click="close">取消</el-button>
        <el-button class="y-w-100" type="primary" @click="verifySmsCode">下一步</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script> 
import Cookies from 'js-cookie';
import timeText from '@/mixins/timeText';
import { 
  getImageVerifyCodeByQuicksettlementApi,//获取图形验证码
  getSmsCodeByQuicksettlementApi,//获取短信验证码
  verifySmsCodeByQuicksettlementApi,//校验短信验证码
} from '../../../api/quickIndemnity/quicksettlement';
export default {
  name: 'setAccount',
  mixins: [timeText],
  props: {
    setAccountInfo:{
      type: Object,
      default: {
        authCode:'', 
        mobile:'',
        active:''
      }
    },
  },
  data() {
    return {
       timeText: '获取验证码',
       src: '',
       setAccountForm: {
        authCode:'',
        mobile: '',
        picSmsCode: '',
        smsCode: ''
      },
      setAccountFormRules: {
        mobile: [
          { required: false, message: '姓名不能为空', trigger: ['change', 'blur'] },
        ],
        picSmsCode: [
          { required: true, message: '图片验证码不能为空', trigger: ['change', 'blur'] },
        ],
        smsCode: [
          { required: true, message: '短信验证码不能为空', trigger: ['change', 'blur'] },
        ]
      },
      authCode:'',
    };
  },
  created(){
    // let time = Cookies.get('smsCode9');
    // if (time) {
    //   let showTime = 60 - parseInt((new Date().getTime() - new Date(time).getTime()) / 1000);
    //   this.timeText = showTime;
    //   this.setText();
    // }
    this.setAccountForm.mobile = this.setAccountInfo.mobile
    this.refreshPic(this.setAccountInfo.authCode)
  },
  methods: {
    close(){
      this.$nextTick(() => {
        this.$emit('close');
      })
    },
    // 获取图片验证码
    refreshPic(code) {
      getImageVerifyCodeByQuicksettlementApi(code).then(res => {
        console.log(res.data.imageVerifyCode)
        if (res.data && res.data.imageVerifyCode) {
          this.src = res.data.imageVerifyCode;
        } else {
          this.$message.error('服务器返回内容有误！');
        }
      });
    },
    // 获取短信验证码
    sendSmsCode() {
      if (this.setAccountForm.picSmsCode === '') {
        this.$message({
          type: 'warning',
          message: '图片验证码不能为空'
        });
        return false;
      }
      this.authCode = '';
      getSmsCodeByQuicksettlementApi(this.setAccountForm.picSmsCode).then((res) => {
        // res={"code":1,"data":"短信验证码发送成功","errorCode":0,"time":"2023-02-28 16:54:23","message":"ok","status":200}
        if (res && (res.hasOwnProperty('error'))) {
          this.$message.error(res.error || '发送失败');
          this.refreshPic(this.setAccountInfo.authCode);
          this.setAccountForm.picSmsCode = '';
        } else {
          if(res && res.data){
            let info = JSON.parse(res.data);
            this.authCode = info.authCode;
          }
          let time = 60;
          // Cookies.set('smsCode9', new Date(), { expires: (1 / (24 * 60)) });
          this.timeText = time;
          this.setText();
        }
      });
    },
    // 校验短信验证码
    verifySmsCode(){
      if (this.setAccountForm.smsCode === '') {
        this.$message({
          type: 'warning',
          message: '短信验证码不能为空'
        });
        return false;
      }
      verifySmsCodeByQuicksettlementApi(this.setAccountForm.smsCode+'&authCode='+this.authCode).then(res => {
        // res = {"status":-50000,"message":"网络异常，请稍后重试~~","timestamp":"2023-02-28T16:55:04.394+08:00"}
        // res = {"code":1,"data":"{\"authCode\":\"e429af392983f26c8e1f291921ecbc18\"}","errorCode":0,"time":"2023-02-28 16:55:08","message":"ok","status":200}
        if (res.status && res.status == 200) {
          this.$nextTick(() => {
            this.$emit('next','setAccount',res.data,1)
          })
        } else {
          this.$message.error(res.error || '校验失败');
        }
      }).catch(() => {
        this.$message.error('校验失败');
      });
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
#setAccount{
  .setAccount-form{
    .el-form-item--small.el-form-item{
      margin: 0 auto 18px auto;
    }
    .el-textarea{
      width: 440px;
    }
    .form-btn{
      display: block;
      margin-left: 0;
      margin-top: 40px!important;
      text-align: center;
    }
  }
}
</style>